export const tabs = {
    RECENT_ITEMS: 0,
    LAST_UPDATES: 1,
    ACTIVE_SCREENS: 2
};
